module.exports = flarum.reg.get('core', 'forum/utils/slidable');